import React from 'react'

import example_screenshot2 from './hero.webp';
import example_screenshot3 from './embed.webp';
import polymedia_png from '../../images/polymedia-peter-van-der-meer-black.png';
import icon_wordpress from '../../images/wordpress-icon.webp';
import icon_html from '../../images/html-icon.webp';
import icon_react from '../../images/react-icon.webp';
import icon_vue from '../../images/vue-icon.webp';
import icon_angular from '../../images/angular-icon.webp';

import StartFooterCTA from './StartFooterCTA.js';


export default class extends React.Component {
  render() {
    let alt_nl = document.createElement('link');alt_nl.rel = 'alternate';alt_nl.hreflang = 'x-default';alt_nl.href = 'https://citrus.polymedia.nl/start';
    document.getElementsByTagName('title')[0].after(alt_nl);
    let alt_en = document.createElement('link');alt_en.rel = 'alternate';alt_en.hreflang = 'en';alt_en.href = 'https://citrus.polymedia.nl/en/start';
    document.getElementsByTagName('title')[0].after(alt_en);
    return (
      <div>
        <div className="full header">
          <div className="wrap">
            <div>
              <div className="col-2" style={{textAlign:"left"}}>
                <h1 style={{margin:"1rem 0"}}>{this.props.i18n_texts["start_header_title"][this.props.app_language]}</h1>
                <h2 style={{margin:"0 0 2em"}}>{this.props.i18n_texts["start_header_subtitle"][this.props.app_language]}</h2>
                <div style={{textAlign:"center"}}><button onClick={() => this.props.openModal("register")} className="btn btn-c btn-fat">{this.props.i18n_texts["start_header_button"][this.props.app_language]}</button><small style={{opacity:".5", display:"block", marginTop:"1em", fontSize:"75%", textAlign:"center"}}>{this.props.i18n_texts["start_header_button_disclaimer"][this.props.app_language]}</small></div>
              </div>
              <div className="col-2">
                {this.props.app_language === "NL" && <div style={{maxWidth:"550px", margin:"4rem auto 6rem"}}><div dangerouslySetInnerHTML={{__html: '<iframe src="https://citrus.polymedia.nl/quickpollmedia/3UIOH1SepwWZ3TTgVoXhdVbvFjOFasLV?embed" height="477" style="border:0;width:100%"></iframe>'}} /><small style={{opacity:".5", display:"block", marginTop:"1em", fontSize:"75%", textAlign:"center"}}>{this.props.i18n_texts["start_header_example"][this.props.app_language]}</small></div>}
                {this.props.app_language === "EN" && <div style={{maxWidth:"550px", margin:"4rem auto 6rem"}}><div dangerouslySetInnerHTML={{__html: '<iframe src="https://citrus.polymedia.nl/quickpollmedia/fhvdj52dtTjvhjeoCql2LnpnYi08apW2?embed" height="477" style="border:0;width:100%"></iframe>'}} /><small style={{opacity:".5", display:"block", marginTop:"1em", fontSize:"75%", textAlign:"center"}}>{this.props.i18n_texts["start_header_example"][this.props.app_language]}</small></div>}
              </div>
            </div>
          </div>
        </div>

        <div className="full big greyish">
          <div className="wrap content-block">
            <h2>{this.props.i18n_texts["start_usps_title"][this.props.app_language]}</h2>
              <div className="col-2 usp">
                <h3>{this.props.i18n_texts["start_usps1_title"][this.props.app_language]}</h3><p>{this.props.i18n_texts["start_usps1_text"][this.props.app_language]}</p>
                <h3>{this.props.i18n_texts["start_usps2_title"][this.props.app_language]}</h3><p>{this.props.i18n_texts["start_usps2_text"][this.props.app_language]}</p>
                <h3>{this.props.i18n_texts["start_usps3_title"][this.props.app_language]}</h3><p>{this.props.i18n_texts["start_usps3_text"][this.props.app_language]}</p>
              </div>
              <div className="col-2"><img src={example_screenshot2} alt={this.props.i18n_texts["start_img_alt1"][this.props.app_language]} className="screenshot" style={{margin:"0"}} /></div>
          </div>
        </div>

        <div className="full big">
          <div className="wrap content-text">
            <h2 className="cta-title" style={{color:"#ff9934"}}>{this.props.i18n_texts["start_cta_title"][this.props.app_language]}</h2>
            <p style={{textAlign:"center", opacity:".8"}}>{this.props.i18n_texts["start_cta_text"][this.props.app_language]}</p>
            <div style={{textAlign:"center"}}><button onClick={() => this.props.openModal("register")} className="btn btn-b btn-fat">{this.props.i18n_texts["start_cta_button"][this.props.app_language]}</button></div>
          </div>
        </div>

        <div className="greyish" style={{padding:"1em 0 3em"}}>
          <div className="wrap content-block">
            {this.props.app_language === "NL" && <h2>Ondersteunt</h2>}
            {this.props.app_language === "EN" && <h2>Supports</h2>}
            <div className="col-6"><img src={icon_wordpress} alt="WordPress" className="screenshot" style={{margin:"0"}} /></div>
            <div className="col-6"><img src={icon_html} alt="HTML" className="screenshot" style={{margin:"0"}} /></div>
            <div className="col-6"><img src={icon_react} alt="React.js" className="screenshot" style={{margin:"0"}} /></div>
            <div className="col-6"><img src={icon_vue} alt="Vue.js" className="screenshot" style={{margin:"0"}} /></div>
            <div className="col-6"><img src={icon_angular} alt="Angular" className="screenshot" style={{margin:"0"}} /></div>
            {this.props.app_language === "NL" && <div className="col-6 many-more">En nog veel meer..</div>}
            {this.props.app_language === "EN" && <div className="col-6 many-more">And many more..</div>}
          </div>
        </div>

        <div className="full big">
          <div className="wrap content-block">
            <h2 style={{marginBottom:".7em"}}>{this.props.i18n_texts["start_embed_title"][this.props.app_language]}</h2>
            <h3 style={{textAlign:"center", margin:"0"}}>{this.props.i18n_texts["start_embed_text"][this.props.app_language]}</h3>
            <img src={example_screenshot3} alt={this.props.i18n_texts["start_img_alt2"][this.props.app_language]} className="screenshot" />
          </div>
        </div>

        <div className="full big orange">
          <div className="wrap content-block">
              <div className="col-2"><img src={polymedia_png} alt={this.props.i18n_texts["start_img_alt3"][this.props.app_language]} className="screenshot" style={{margin:"0"}} /></div>
              <div className="col-2">
                <h1 style={{margin:"1rem 0", textAlign:"center"}}>{this.props.i18n_texts["start_who_title"][this.props.app_language]}</h1>
                <p style={{fontSize:"20px", textAlign:"left", marginTop:"0"}}>{this.props.i18n_texts["start_who_text1"][this.props.app_language]}<br/><br/>{this.props.i18n_texts["start_who_text2"][this.props.app_language]}</p>
                <div className="socials"><a href="https://www.linkedin.com/in/peterdotplus/" target="_blank" rel="noopener noreferrer" style={{marginRight:"42px"}}>LinkedIn</a><a href="https://x.com/PolymediaNL" target="_blank" rel="noopener noreferrer">Twitter</a></div>
              </div>
          </div>
        </div>

        <div className="full big">
          <div className="wrap wrap-thin content-block">
            <h2 style={{marginBottom:".7em"}}>{this.props.i18n_texts["start_faq_title"][this.props.app_language]}</h2>
            <h3 style={{margin:"1em 0 0"}}>{this.props.i18n_texts["start_faq1_title"][this.props.app_language]}</h3>
            <p style={{margin:"0"}} dangerouslySetInnerHTML={{__html:this.props.i18n_texts["start_faq1_text"][this.props.app_language]}}/>
            <h3 style={{margin:"1em 0 0"}}>{this.props.i18n_texts["start_faq2_title"][this.props.app_language]}</h3>
            <p style={{margin:"0"}}>{this.props.i18n_texts["start_faq2_text"][this.props.app_language]}</p>
            <h3 style={{margin:"1em 0 0"}}>{this.props.i18n_texts["start_faq3_title"][this.props.app_language]}</h3>
            <p style={{margin:"0"}} dangerouslySetInnerHTML={{__html:this.props.i18n_texts["start_faq3_text"][this.props.app_language]}}/>
          </div>
        </div>

        <StartFooterCTA lang={this.props.app_language} openModal={this.props.openModal} />

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/StartPages/Start.js